var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "card-financeiro",
        { attrs: { cardTitle: "Resumo" } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("app-divider", {
                staticClass: "margin-bottom-20",
                attrs: { label: " Emissão do DAE", showBorder: true }
              }),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Número do processo:  ")
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.dadosDae.processoFisico.numero || "-"))
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Telefone:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.dadosDae.processoFisico.telefone || "-")
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Nome/Razão social do interessado:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.dadosDae.processoFisico
                            .nomeRazaoSocialInteressado || "-"
                        )
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("CPF/CPNJ do interessado:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.dadosDae.processoFisico.cpfCnpjInteressado || "-"
                        )
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Município:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.dadosDae.processoFisico.endereco.municipio.nome ||
                            "-"
                        )
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Endereço:  ")
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.getEndereco()))])
                  ])
                ],
                1
              ),
              _c("app-divider", {
                staticClass: "margin-bottom-20",
                attrs: {
                  label:
                    "Custas " +
                    (this.dadosDae.tipoCusta === "PROCESSUAIS"
                      ? "processuais"
                      : "agrárias"),
                  showBorder: true
                }
              }),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c(
                    "el-table",
                    { attrs: { data: this.dadosDae.custas } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Discriminação",
                          prop: "tipoCusta.descricao",
                          "min-width": "500"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Quantidade",
                          prop: "quantidade",
                          "min-width": "150"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("app-divider", {
                staticClass: "margin-bottom-20",
                attrs: { label: " Dados do DAE", showBorder: true }
              }),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Receita:  ")
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.dadosDae.tipoReceita.descricao || "-"))
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Valor total:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(
                            _vm._f("formatDouble")(_vm.dadosDae.valorTotal)
                          )
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Data de vencimento:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarData(_vm.dadosDae.dataVencimento))
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Data do cálculo:  ")
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatarData(_vm.dadosDae.dataCalculo)))
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Referência:  ")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatarDataMesAno(_vm.dadosDae.dataReferencia)
                        )
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "rowResumo" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Informações adicionais:  ")
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.dadosDae.informacoesAdicionais || "-"))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("app-buttons-cadastro", {
        attrs: {
          isPrimeiroPasso: false,
          isUltimoPasso: true,
          showButtonSalvar: false,
          isEtapaSalva: false
        },
        on: {
          cancelar: _vm.cancelar,
          voltar: _vm.voltar,
          finalizar: _vm.finalizar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a091570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a091570","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/dae/ResumoDae.vue
// module id = null
// module chunks = 